module.exports = __webpack_public_path__ + "media/post-listing-block-6-image-step3.5b9a0886.png";